import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Caption } from "../../atoms/views/Caption";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { ContactDateIcon } from "../../atoms/icons/ContactDateIcon";
import { useTranslation } from 'react-i18next';



// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<Date>;
export const ContactDatum = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');


    const label = props.label || tDatatypes('contactDatumLabel') || "Contact Datum";

    return (<Caption {...props} caption={label} icon={<ContactDateIcon />}>
        {props.value.toLocaleDateString()}
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));